import React, { useRef, useContext } from "react";
import "../css/reset.css";
import "../css/review.css";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  EffectCoverflow,
  Scrollbar,
  FreeMode,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";
import arrow from "../img/review/arrow.png";

// 데이터와 Context를 import합니다.
import { ReviewData } from "./ReviewData";
import { ModalContext } from "../context/ModalContext";

const Review = () => {
  // Context를 통해 상위 컴포넌트(LayoutCom)의 모달 열기 함수를 가져옵니다.
  const { openReviewModal } = useContext(ModalContext);
  const swiperRef = useRef(null);

  return (
    <>
      <section className="Review_wrap" id="ReviewSection" name="ReviewSection">
        <div className="Review_inner">
          <div className="title_wrap">
            <h3>REVIEW</h3>
            <strong>고객이 먼저 말하는 만족도</strong>
          </div>
          <div className="Review_box_wrap">
            <div className="Review_scroll_wrap scroll-container">
              <Swiper
                ref={swiperRef}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                }}
                className="Review_box_slide"
                spaceBetween={20}
                slidesPerView={"auto"}
                breakpoints={{
                  700: {
                    spaceBetween: 40,
                  },
                }}
                modules={[Navigation, EffectCoverflow, Scrollbar, FreeMode]}
                loop={false}
                direction="horizontal"
                allowTouchMove={true}
                freeMode={true}
                scrollbar={{
                  hide: false,
                  draggable: true,
                  dragSize: 100,
                }}
              >
                {ReviewData &&
                  ReviewData.map((item) => (
                    <SwiperSlide key={item.id}>
                      <span className="ReviewItem">
                        <figure className="">
                          <img src={item.image} alt={item.name} />
                          <figcaption>
                            <h2> {item.name} </h2>
                            <span>
                              {item.types.map((type, index) => (
                                <img key={index} src={type} alt={type} />
                              ))}
                            </span>
                          </figcaption>
                        </figure>
                        <h2>{item.title}</h2>
                        <p>{item.longText}</p>
                        {/* 버튼 클릭 시 Context의 함수를 호출합니다. */}
                        <button onClick={() => openReviewModal(item.id)}>
                          자세히 보기 <img src={arrow} alt="자세히 보기" />
                        </button>
                      </span>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Review;
